module.exports = __webpack_public_path__ + "static/media/Logo.3239a30e.PNG";